<script>
    import {fade} from 'svelte/transition'
    import AllAlerts from "./all_alerts.svelte"
    import CurrentWatch from "./current_watch.svelte"
</script>
<div class="container-fluid" transition:fade="{{duration: 200}}">
    <div class="row page-titles">
        <div class="col-md-5 col-8 align-self-center">
            <h3 class="text-themecolor">Equipment Summary</h3>
            <ol class="breadcrumb">
                <li class="breadcrumb-item">My Alerts</li>
            </ol>
        </div>
    </div>

    <section>
        <div class="card-group separate">
            <CurrentWatch/>
            <AllAlerts/>
        </div>
    </section>
</div>